requirejs([
    'jquery'
],
function($) {
    var scrollContainer = $(".horizontal-scroll");
    scrollContainer.scroll(function() {
        scrollContainer.scrollLeft($(this).scrollLeft());
    });
});